/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum Business_state {
  NEW = "NEW",
  OLD = "OLD",
}

export enum CLIENT_TYPE {
  ALL = "ALL",
  INSURER = "INSURER",
  REINSURER = "REINSURER",
  RETROCEDENT = "RETROCEDENT",
}

export enum Cheque_status {
  CLEARED = "CLEARED",
  PENDING = "PENDING",
  UNCLEARED = "UNCLEARED",
}

export enum Claim_status {
  CLAIMED = "CLAIMED",
  UNCLAIMED = "UNCLAIMED",
}

export enum Expiry_status {
  ACTIVE = "ACTIVE",
  EXPIRED = "EXPIRED",
}

export enum GeneralReportType {
  CLEARED = "CLEARED",
  QUARTER = "QUARTER",
  RE_PREMIUM_OUTSTANDING = "RE_PREMIUM_OUTSTANDING",
  RE_PREMIUM_PAID = "RE_PREMIUM_PAID",
  UNCLEARED = "UNCLEARED",
}

export enum OfferStatus {
  CLOSED = "CLOSED",
  OPEN = "OPEN",
  PENDING = "PENDING",
}

export enum Offer_status {
  CLOSED = "CLOSED",
  OPEN = "OPEN",
  PENDING = "PENDING",
}

export enum Payment_Type {
  BANKTRANSFER = "BANKTRANSFER",
  CHEQUE = "CHEQUE",
}

export enum Payment_status {
  PAID = "PAID",
  PARTPAYMENT = "PARTPAYMENT",
  UNPAID = "UNPAID",
}

export enum PublishedStatus {
  PUBLISHED = "PUBLISHED",
  UNPUBLISHED = "UNPUBLISHED",
}

export enum Renewal_status {
  NOTRENEWED = "NOTRENEWED",
  RENEWED = "RENEWED",
}

export enum ReportType {
  CLOSED = "CLOSED",
  CREATED = "CREATED",
  EXPIRED = "EXPIRED",
  EXPIRING = "EXPIRING",
}

export enum Sent_status {
  SENT = "SENT",
  UNSENT = "UNSENT",
}

export enum TreatyAccountPeriod {
  FIRSTQUARTER = "FIRSTQUARTER",
  FOURTHQUARTER = "FOURTHQUARTER",
  SECONDQUARTER = "SECONDQUARTER",
  THIRDQUARTER = "THIRDQUARTER",
}

export enum TreatyType {
  NONPROPORTIONAL = "NONPROPORTIONAL",
  PROPORTIONAL = "PROPORTIONAL",
}

export enum status_type {
  APPROVED = "APPROVED",
  UNAPPROVED = "UNAPPROVED",
}

export interface Claim_data {
  offer_id: string;
  claim_amount: string;
  claim_date: string;
  claim_comment?: string | null;
  currency?: string | null;
  rate?: number | null;
}

export interface ClearanceData {
  payment_id: string;
  offer_id: string;
  cleared_date?: any | null;
  reason?: string | null;
  clearance_status: Cheque_status;
}

export interface Email_data {
  offer_id: string;
  reinsurer_id?: string | null;
  subject?: string | null;
  copied_emails?: (string | null)[] | null;
  message_content?: string | null;
  attachment?: string[] | null;
}

export interface EndorsementFilters {
  offset: number;
  limit: number;
  search?: string | null;
  insurer_id?: string | null;
  approval_status?: status_type | null;
  class_of_business_id?: (string | null)[] | null;
  endorsement_status?: string | null;
  year?: string | null;
}

export interface FacultativeReportData {
  payment_type?: Payment_Type | null;
  report_type?: GeneralReportType | null;
  class_of_business_id?: string | null;
  client_type?: CLIENT_TYPE | null;
  client_id?: string | null;
  period_from?: any | null;
  period_to?: any | null;
}

export interface OfferClaimParticipantPaymentInput {
  offer_claim_participant: string;
  claim_share_payment_amount: number;
  payment_details: string;
  payment_comment?: string | null;
  payment_date: any;
}

export interface OfferFilters {
  insurer_id?: (string | null)[] | null;
  offset?: number | null;
  limit?: number | null;
  search?: string | null;
  status?: (string | null)[] | null;
  claim_status?: (string | null)[] | null;
  payment_status?: (string | null)[] | null;
  year?: string | null;
  offer_from?: string | null;
  class_of_business_id?: (string | null)[] | null;
  approval_status?: status_type | null;
  staff_id?: (string | null)[] | null;
  payment_type?: string | null;
  expiry_status?: string | null;
}

export interface OfferFiltersReinsurer {
  reinsurer_id?: string | null;
  offset?: number | null;
  limit?: number | null;
  search?: string | null;
  status?: (string | null)[] | null;
  claim_status?: (string | null)[] | null;
  payment_status?: (string | null)[] | null;
  year?: string | null;
  offer_from?: string | null;
  class_of_business_id?: string | null;
  approval_status?: status_type | null;
  staff_id?: string | null;
  payment_type?: string | null;
  expiry_status?: string | null;
  from?: string | null;
  to?: string | null;
}

export interface OfferPaymentInput {
  offer_id?: string | null;
}

export interface OfferTabsFilter {
  tab_number?: number | null;
  status?: OfferStatus | null;
  search?: string | null;
  dateFrom?: any | null;
  dateTo?: any | null;
}

export interface Offer_data {
  class_of_business_id: string;
  insurer_id: string;
  employee_id: string;
  reinsurer_id?: string | null;
  rate?: number | null;
  commission: number;
  brokerage: number;
  facultative_offer: number;
  sum_insured: number;
  premium: number;
  policy_number?: string | null;
  insured_by: string;
  period_of_insurance_from?: any | null;
  period_of_insurance_to?: any | null;
  currency: string;
  offer_comment?: string | null;
  information_comment?: string | null;
  offer_details: string;
  co_insurance_share?: number | null;
  ex_currency?: string | null;
  ex_rate?: number | null;
  payment_type?: Payment_type | null;
  business_state?: Business_state | null;
}

export interface Offer_payment_data {
  offer_id: string;
  payment_amount: number;
  payment_details: string;
  Offer_payment_comment: string;
  payment_status?: string | null;
  date_of_receipt?: any | null;
  auto_payment_receipt?: boolean | null;
}

export interface Pagination {
  offset?: number | null;
  limit?: number | null;
}

export interface PaymentDetails {
  payment_amount: number;
  treaty_id?: string | null;
  treaty_account_id?: string | null;
  payment_id?: string | null;
  payment_details: string;
  payment_comment?: string | null;
  payment_status: string;
  date_of_receipt?: any | null;
  cheque_clearance_status?: Cheque_status | null;
  uuid?: string | null;
  installment_type?: number | null;
  auto_payment_receipt?: boolean | null;
  default?: boolean | null;
}

export interface Payment_type {
  payable_in_full?: string | null;
  instalment?: string | null;
}

export interface ProductionReportData {
  report_type?: ReportType | null;
  class_of_business_id?: string | null;
  client_type?: CLIENT_TYPE | null;
  client_id?: string | null;
  period_from?: any | null;
  period_to?: any | null;
  offer_status?: (string | null)[] | null;
  payment_status?: (Payment_status | null)[] | null;
}

export interface TreatyFilters {
  insurer_id?: string | null;
  broker_id?: string | null;
  offset?: number | null;
  limit?: number | null;
  search?: string | null;
  treaty_expiry_status?: (string | null)[] | null;
  treaty_claim_status?: (string | null)[] | null;
  treaty_payment_status?: (string | null)[] | null;
  treaty_program_type?: (string | null)[] | null;
  approval_status?: status_type | null;
  year?: string | null;
}

export interface TreatyReportData {
  payment_type?: Payment_Type | null;
  report_type?: GeneralReportType | null;
  treaty_program_id?: string | null;
  client_type?: CLIENT_TYPE | null;
  client_id?: string | null;
  period_from?: any | null;
  period_to?: any | null;
  quarter?: TreatyAccountPeriod | null;
  treaty_type?: TreatyType | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
